import { RotateCcw, Trash2 } from "lucide-react";
import { ColorPick, FontSelect } from "./TextTool";

export const LayerControls = ({ layer, isText, fonts, area, onChange, onRemove }) => {
  const sizeKey = isText ? "size" : "w";
  const [min, max, step] = isText ? [0.02, 0.3, 0.005] : [0.05, 0.9, 0.01];
  return (
    <div className="space-y-3 rounded-xl border border-[#60A5FA]/40 bg-[#2563EB]/5 p-4" data-testid="design-layer-controls">
      <p className="truncate text-xs text-slate-400">{isText ? "Selected text" : layer.filename} · drag it on the item to move</p>
      {isText && (
        <>
          <input className="field" maxLength={100} value={layer.text} onChange={(e) => onChange({ text: e.target.value })} data-testid="design-selected-text-input" />
          <FontSelect fonts={fonts} value={layer.font} onChange={(font) => onChange({ font })} testId="design-selected-font-select" />
          <ColorPick value={layer.color} onChange={(color) => onChange({ color })} testId="design-selected-color" />
        </>
      )}
      <label className="label">Size</label>
      <input type="range" min={min} max={max} step={step} value={layer[sizeKey]} onChange={(e) => onChange({ [sizeKey]: parseFloat(e.target.value) })} className="w-full accent-[#E5202A]" data-testid="design-size-slider" />
      <label className="label">Rotate ({Math.round(layer.rot)}°)</label>
      <input type="range" min="-180" max="180" step="1" value={layer.rot} onChange={(e) => onChange({ rot: parseFloat(e.target.value) })} className="w-full accent-[#2563EB]" data-testid="design-rotate-slider" />
      <div className="flex justify-between text-sm">
        <button type="button" onClick={() => onChange({ rot: 0, cx: (area.x + area.w / 2) / 100, cy: (area.y + area.h / 2) / 100 })} className="flex items-center gap-1 text-slate-300 hover:text-white" data-testid="design-center-button"><RotateCcw className="h-4 w-4" />Center</button>
        <button type="button" onClick={onRemove} className="flex items-center gap-1 text-slate-400 hover:text-red-400" data-testid="design-remove-button"><Trash2 className="h-4 w-4" />Remove</button>
      </div>
    </div>
  );
};
